export default __webpack_public_path__ + "/dist/images/logo7.07963dbd0067f99b4be94e93b10319f8.jpg";